import React, { createContext, useContext, ReactNode } from "react";
import { useWizard, WizardStep } from "@/hooks/useWizard";
import { Template } from "@/types";

interface WizardContextType {
  selectedFile: File | null;
  /** Новый выбор файла: сбрасывает шаблон и параметры встречи. */
  selectFile: (file: File | null) => void;
  selectedTemplate: Template | null;
  setSelectedTemplate: (template: Template | null) => void;
  currentStep: number;
  steps: WizardStep[];
  goToPreviousStep: () => void;
  resetWizard: () => void;
  canGoBack: boolean;
  getCurrentStep: () => WizardStep | undefined;
  speakerNames: string;
  setSpeakerNames: (value: string) => void;
  meetingContext: string;
  setMeetingContext: (value: string) => void;
  meetingParamsOpen: boolean;
  setMeetingParamsOpen: (open: boolean) => void;
}

const WizardContext = createContext<WizardContextType | undefined>(undefined);

interface WizardProviderProps {
  children: ReactNode;
}

export const WizardProvider = ({ children }: WizardProviderProps) => {
  const wizard = useWizard();

  return <WizardContext.Provider value={wizard}>{children}</WizardContext.Provider>;
};

export const useWizardContext = () => {
  const context = useContext(WizardContext);
  if (context === undefined) {
    throw new Error("useWizardContext must be used within a WizardProvider");
  }
  return context;
};
